if (!customElements.get('osiris-hero-rotator')) {
  customElements.define('osiris-hero-rotator', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.frames = [...this.querySelectorAll('[data-hero-frame]')];
      this.controls = this.querySelector('[data-hero-controls]');
      if (this.frames.length < 2 || !this.controls) return;
      this.section = this.closest('.osiris-hero');
      this.index = Math.max(0, this.frames.findIndex(frame => frame.classList.contains('is-active')));
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.visible = false;
      this.busy = false;
      this.interval = Math.max(3000, Math.min(4000, Number(this.dataset.interval) * 1000 || 4000));
      this.controls.hidden = false;
      this.querySelector('[data-hero-prev]').addEventListener('click', () => this.manual(-1), { signal });
      this.querySelector('[data-hero-next]').addEventListener('click', () => this.manual(1), { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.reduced.addEventListener('change', () => this.schedule(), { signal });
      this.connection?.addEventListener('change', () => this.schedule(), { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .2);
        this.schedule();
      }, { threshold: [0, .2] });
      this.observer.observe(this.section);
      this.updateControls();
    }
    canRotate() {
      return this.isConnected && this.visible && !document.hidden && !this.reduced.matches && !this.connection?.saveData;
    }
    schedule() {
      clearTimeout(this.timer);
      this.updateControls();
      this.classList.toggle('is-running', this.canRotate());
      if (this.canRotate() && !this.busy) this.timer = setTimeout(() => this.move(1, true), this.interval);
    }
    updateControls() {
      this.querySelector('[data-hero-count]').textContent = `${this.index + 1} / ${this.frames.length}`;
      if (this.section?.dataset.bfEnabled === 'true') {
        const campaign = this.index < 2;
        this.section.classList.toggle('is-bf', campaign);
        this.section.querySelectorAll('[data-bf-only]').forEach(el => { el.hidden = !campaign; });
        this.section.querySelectorAll('[data-default-only]').forEach(el => { el.hidden = campaign; });
        const title = this.section.querySelector('[data-hero-title]');
        const origin = this.section.querySelector('[data-hero-origin]');
        title.textContent = campaign ? title.dataset.bf : title.dataset.original;
        origin.textContent = campaign ? origin.dataset.bf : origin.dataset.original;
      }
    }
    manual(direction) {
      return this.move(direction);
    }
    async move(direction, automatic = false) {
      if (this.busy || (automatic && !this.canRotate())) return;
      clearTimeout(this.timer);
      this.busy = true;
      const signal = this.abort.signal;
      const next = (this.index + direction + this.frames.length) % this.frames.length;
      const frame = this.frames[next];
      const template = frame.querySelector('template');
      if (template) {
        frame.append(template.content.cloneNode(true));
        template.remove();
      }
      try {
        await frame.querySelector('img').decode();
        if (signal.aborted || !this.isConnected || (automatic && !this.canRotate())) return;
        this.frames[this.index].classList.remove('is-active');
        frame.classList.add('is-active');
        this.index = next;
        this.dataset.activeSlide = String(next + 1);
      } catch (_) {
      } finally {
        if (!signal.aborted && this.isConnected) {
          this.busy = false;
          this.schedule();
        }
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}

